module.exports = __webpack_public_path__ + "img/aviatorgt-22.4229720c.png";